import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "6",
  viewBox: "0 0 8 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.176 2.65101C2.71539 3.18581 3.58505 3.18581 4.12445 2.65101L6.20249 0.590669C6.53233 0.263637 7.06413 0.263638 7.39398 0.59067C7.72783 0.921682 7.72783 1.46138 7.39398 1.79239L4.55837 4.60384C3.77873 5.37684 2.52171 5.37684 1.74207 4.60384L0.606024 3.47748C0.272168 3.14646 0.272169 2.60676 0.606025 2.27575C0.935866 1.94872 1.46767 1.94872 1.79751 2.27575L2.176 2.65101Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }